import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { trackGAEvent } from '../../analytics/GoogleAnalytics';
import useAccountContext from '../../authentication/hooks';
import useUserServices from '../../hooks/useUserServices';
import { ServiceType } from '../../api/web-api-client';

const DisplayUserAndOrgName = () => {
    const account = useAccountContext();
    return (
        <>
            <span className='d-block user-name fw-bold text-break'>
                <span className='visually-hidden'>{'User signed in as: '}</span>
                {account?.details?.givenName}
                {' '}
                {account?.details?.familyName}
                <span className='visually-hidden'>,</span>
            </span>
            <span className='d-block org-name text-break'>
                {!!(account?.details?.trading) && (`${account?.details?.trading}`)}
                {!!(account?.details?.trading) && !!(account?.details?.branch) && (' - ')}
                {!!(account?.details?.branch) && (`${account?.details?.branch}`)}
            </span>
            <span className='d-block org-name text-break'>
                {account?.details?.organisation}
            </span>
        </>
    );
};

const NON_BRANCHABLE_SERVICES = [
    ServiceType.PatternApproval,
    // Add more service types here as needed
];

const AuthenticatedNavbarItems = () => {
    const account = useAccountContext();
    const services = useUserServices();

    if (!services || services.length === 0) {
        return null;
    }

    // Find the default service (assuming only one can be default)
    const defaultService = services.find((s) => s.isDefault);

    let isNonBranchable = false;

    if (!defaultService) isNonBranchable = true;
    else {
        isNonBranchable = NON_BRANCHABLE_SERVICES.includes(defaultService!.service!);
    }

    if (!account?.details?.email) {
        return null;
    }

    const onShowBranchSelectorClick = () => { account.setShowBranchSelector(true); };

    return (
        <Dropdown
            align='end'
            id='user-menu-dropdown'
            data-testid='user-menu-dropdown'
        >
            <Dropdown.Toggle
                id='user-menu'
                variant='dark'
            >
                <h2 className='visually-hidden text-white'>Current user settings menu</h2>
                <div className='d-none d-md-block text-end me-2'>
                    <DisplayUserAndOrgName />
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu variant='dark'>
                <Dropdown.ItemText className='d-block d-md-none'>
                    <DisplayUserAndOrgName />
                </Dropdown.ItemText>
                <Dropdown.Item
                    as={Link}
                    to='/services-we-offer?mode=manage'
                    onClick={() => { trackGAEvent('Maage Services We Offer'); }}
                >
                    Manage NMI services
                </Dropdown.Item>
                <Dropdown.Item
                    as={Link}
                    to={`/update-organisation/${account.details.defaultOrganisationId}`}
                    onClick={() => { trackGAEvent('Manage organisation'); }}
                >
                    Manage organisation
                </Dropdown.Item>
                {!isNonBranchable && (
                    <Dropdown.Item
                        as={Link}
                        onClick={() => {
                            onShowBranchSelectorClick();
                            trackGAEvent('Manage branch/location');
                        }}
                        to='/dashboard#0'
                    >
                        Add or manage branch/location
                    </Dropdown.Item>
                )}

                <Dropdown.Item
                    as={Link}
                    to='/update-contact'
                    onClick={() => { trackGAEvent('Manage contact'); }}
                >
                    My contact details
                </Dropdown.Item>
                <Dropdown.Item
                    as={Link}
                    to='/sign-out'
                    onClick={() => { trackGAEvent('sign out'); }}
                >
                    Log out
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default AuthenticatedNavbarItems;
